import {HolidayCategory} from '../modules/booking-flow/holiday/holiday-search-page/interfaces/holiday-category';

export default function formatHolidayCategory(cat: string, type: string): HolidayCategory {
  let value;
  let extra;
  let icon;
  let label;
  let unicodeIcon;
  if (cat.includes('/')) {
    value = parseInt(cat.replace(/\*/g, ''), 10);
    icon = 'icon-star';
    unicodeIcon = '⭐';
    label = 'Stelle';
  } else if (cat.includes('Chiavi')) {
    [value, label] = cat.split(' ');
    icon = 'icon-key';
    unicodeIcon = '🔑';
    value = parseInt(value, 10);
  } else if (cat.includes('Girasoli')) {
    [value, label] = cat.split(' ');
    icon = 'icon-sunflower';
    unicodeIcon = '🌻';
    value = parseInt(value, 10);
  } else if (cat.includes('Spighe')) {
    [value, label] = cat.split(' ');
    icon = 'icon-wheat';
    unicodeIcon = '🌾';
    value = parseInt(value, 10);
  } else if (cat.includes('Tour')) {
    value = 0;
    label = cat;
  } else if (cat.includes('*')) {
    [value] = cat.split('*');
    value = parseInt(value, 10);
    icon = 'icon-star';
    unicodeIcon = '⭐';
    label = 'Stelle';
  } else if (cat.includes('ND') || !cat) {
    value = 0;
    label = 'Nessuna Categoria';
  } else {
    [value, label] = cat.split('');
    value = parseInt(value, 10);
  }
  if (cat.includes('S')) {
    extra = 'S';
  }
  if (cat.includes('L')) {
    extra = 'L';
  }
  return {
    id: cat, label, extra, value, icon, unicodeIcon
  };
}
